import { Component, Input } from '@angular/core';

import { TrackerAdmin } from '../../../entities/index';
import { TrackerAdminService } from '../../../services/trackeradmin.service';
import {Log} from '../../../utils';
import {NotificationsService} from 'angular2-notifications';

@Component({
  selector: 'app-tracker-admin',
  templateUrl: './tracker-admin.html'
})
export class TrackerAdminComponent {
  loading = true;
  trackerAdmin: TrackerAdmin;

  constructor(protected trackeradminService: TrackerAdminService,
              protected notification: NotificationsService) {}

  @Input()
  set imei(imei: string) {
    if (!imei) {
      this.trackerAdmin = null;
      return;
    }

    this
      .trackeradminService
      .findOneByImei(String(imei))
      .subscribe(
        (trackerAdmin: TrackerAdmin) => {
          this.trackerAdmin = trackerAdmin;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  @Log('blue')
  activateSim() {
    this.trackeradminService
      .activateSim(this.trackerAdmin.id)
      .subscribe(_ => {
        this.notification.success('SUCCESS', 'The sim has been activated.');
      });
  }

  @Log('blue')
  deactivateSim() {
    this.trackeradminService
      .deactivateSim(this.trackerAdmin.id)
      .subscribe(_ => {
        this.notification.success('SUCCESS', 'The sim has been deactivated.');
      });
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/blocks/tracker-admin/tracker-admin.component.ts